module.exports = __webpack_public_path__ + "static/media/msg-ok.7308b84b.svg";